import { acpTokens } from './tokens'

const { acp: acpColors } = acpTokens.colors
const { radii: acpRadii } = acpTokens

export const ACP_COLORS = {
  BLUE: acpColors.blue.value,
  BLUE_LIGHT: acpColors.blueLight.value,
  GOLD: acpColors.gold.value,
  INK: acpColors.ink.value,
  INK_SOFT: acpColors.inkSoft.value,
  INK_FAINT: acpColors.inkFaint.value,
  BG: acpColors.bg.value,
  BG_SOFT: acpColors.bgSoft.value,
  SURFACE: acpColors.surface.value,
  SURFACE_ALT: acpColors.surfaceAlt.value,
  LINE: acpColors.line.value,
  LINE_STRONG: acpColors.lineStrong.value,
} as const

export const ACP_RADII = {
  CARD: acpRadii.card.value,
  BUTTON: acpRadii.button.value,
} as const

export const ACP_VARIANTS = {
  BUTTON: {
    PRIMARY: 'acp-primary',
    SECONDARY: 'acp-secondary',
    OUTLINE: 'acp-outline',
    GHOST: 'acp-ghost',
    DANGER: 'acp-danger',
    SUCCESS: 'acp-success',
  },
  BADGE: {
    DRAFT: 'acp-draft',
    PUBLISHED: 'acp-published',
    TAG: 'acp-tag',
    PENDING: 'acp-pending',
    STARTING: 'acp-starting',
    RUNNING: 'acp-running',
    WAITING: 'acp-waiting',
    COMPLETED: 'acp-completed',
    FAILED: 'acp-failed',
    STOPPED: 'acp-stopped',
    GOLD: 'acp-gold',
    INFO: 'acp-info',
  },
  CARD: {
    DEFAULT: 'acp-card acp-card-default',
    ELEVATED: 'acp-card acp-card-elevated',
    OUTLINED: 'acp-card acp-card-outlined',
    SUBTLE: 'acp-card acp-card-subtle',
    HOVERABLE: 'acp-card-hoverable',
    CLICKABLE: 'acp-card-clickable',
  },
  INPUT: {
    DEFAULT: 'acp-input',
    ERROR: 'acp-input-error',
  },
  SPINNER: {
    PRIMARY: 'acp-spinner-primary',
    ACCENT: 'acp-spinner-accent',
    GOLD: 'acp-spinner-gold',
    MINIMAL: 'acp-spinner-minimal',
  },
} as const

export const ACP_SEMANTIC_TOKENS = {
  BRAND: {
    SOLID: 'acp.blue',
    CONTRAST: 'white',
    SUBTLE: 'acp.bgSoft',
    MUTED: 'acp.inkFaint',
    EMPHASIS: 'acp.ink',
  },
  ACTION: {
    PRIMARY: 'acp.blue',
    PRIMARY_HOVER: 'acp.blueLight',
    SECONDARY: 'acp.gold',
    DISABLED: 'acp.inkFaint',
  },
  STATUS: {
    SUCCESS: 'green.600',
    WARNING: 'acp.gold',
    ERROR: 'red.500',
    INFO: 'acp.blue',
    NEUTRAL: 'acp.inkFaint',
  },
  SURFACE: {
    PRIMARY: 'acp.surface',
    SECONDARY: 'acp.bgSoft',
    ACCENT: 'acp.ink',
    OVERLAY: 'blackAlpha.600',
  },
} as const

export const ACP_TRANSITIONS = {
  DEFAULT: 'all 0.2s',
  FAST: 'all 0.15s ease',
  BASE: 'all 0.25s ease',
} as const

export const ACP_SHADOWS = {
  SM: '0 1px 2px rgba(0, 0, 0, 0.05)',
  MD: '0 4px 6px rgba(0, 0, 0, 0.07)',
  LG: '0 10px 15px rgba(0, 0, 0, 0.1)',
  CARD_DEFAULT: '0 1px 3px rgba(0, 0, 0, 0.06)',
  CARD_HOVER: '0 4px 12px rgba(0, 0, 0, 0.1)',
  CARD_ELEVATED: '0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)',
} as const

export type ButtonVariant = typeof ACP_VARIANTS.BUTTON[keyof typeof ACP_VARIANTS.BUTTON]
export type BadgeVariant = typeof ACP_VARIANTS.BADGE[keyof typeof ACP_VARIANTS.BADGE]
export type CardVariant = typeof ACP_VARIANTS.CARD[keyof typeof ACP_VARIANTS.CARD]
export type InputVariant = typeof ACP_VARIANTS.INPUT[keyof typeof ACP_VARIANTS.INPUT]
export type SpinnerVariant = typeof ACP_VARIANTS.SPINNER[keyof typeof ACP_VARIANTS.SPINNER]
